import { AI_REPORTING_REDIRECT_PATH } from "@finway-group/shared/lib/consts/route.constants"
import { PROCESS_ENV } from "~Shared/config/env.utils"

export { AI_REPORTING_REDIRECT_PATH }

/** Absolute URL of the Finway API `/ai-reporting` redirect, opened to start the AI reporting login + OIDC flow. */
export const getOpenInOidcClientAppUrl = (apiBaseUrl: string = PROCESS_ENV.API_URL ?? ""): string => `${apiBaseUrl.replace(/\/+$/, "")}${AI_REPORTING_REDIRECT_PATH}`
